// ============================================================================
// Push Supabase auth into the JobFlow browser extension (content script relay).
// Anon-visible tokens only survive in extension storage until sign-out clears.
// ============================================================================

import type { Session } from '../types/auth'

export function broadcastExtensionAuthSession(session: Session | null): void {
  if (globalThis.window === undefined || globalThis.window === null) return

  const targetOrigin =
    typeof globalThis.window.location.origin === 'string'
    && globalThis.window.location.origin.length > 0
      ? globalThis.window.location.origin
      : '*'

  globalThis.window.postMessage(
    {
      source: 'jobflow-webapp',
      type: 'EXTENSION_AUTH_SESSION',
      payload: session
        ? {
            access_token: session.accessToken,
            refresh_token: session.refreshToken,
            expires_at: session.expiresAt,
          }
        : null,
    },
    targetOrigin,
  )
}
